/**
 * Web counterpart to deepLinkTransport.ts. On web, "the URL the app was
 * opened with" is just the address bar — no OS-level link-open event
 * exists or is needed. `popstate` covers back/forward browser navigation;
 * ordinary in-app `navigation.navigate(...)` calls already update the
 * address bar on their own (React Navigation's own web integration, driven
 * by the existing `config.screens` path map in navigation/index.tsx) and
 * don't need a listener here.
 */
export async function getInitialDeepLinkUrl(): Promise<string | null> {
  if (typeof window === 'undefined') return null;
  return window.location.href;
}

export function subscribeToDeepLinks(listener: (url: string) => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const handlePopState = () => listener(window.location.href);
  window.addEventListener('popstate', handlePopState);
  return () => window.removeEventListener('popstate', handlePopState);
}
